import { useQuery } from '@tanstack/react-query';
import { StatCardGrid } from '@/components/common/StatCardGrid';
import { moTravelStatsQueryOptions } from '../api/moTravel.api';
import type { MoTravelFilterParams, MoTravelStats } from '../types/moTravel.types';

interface MoTravelStatsCardConfig {
  key: keyof MoTravelStats;
  label: string;
}

const MO_TRAVEL_STATS_CARDS: MoTravelStatsCardConfig[] = [
  { key: 'officerCount', label: 'Total ZM' },
  { key: 'submittedCount', label: 'Submitted' },
  { key: 'noLocationCount', label: 'No GPS' },
  { key: 'totalEntry', label: 'Total entries' },
];

interface MoTravelStatsCardsProps {
  params: MoTravelFilterParams;
}

export function MoTravelStatsCards({ params }: MoTravelStatsCardsProps) {
  const { data, isLoading, isError } = useQuery(moTravelStatsQueryOptions(params));

  return (
    <StatCardGrid
      stats={MO_TRAVEL_STATS_CARDS.map((card) => ({ ...card, value: data?.[card.key] }))}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
